let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gGQIc")).then(() => parcelRequire('5nmGk'));